export enum InteractionSources {
    CONNECT = 'CONNECT'
}
